import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const SoftwareMaintenancePage: React.FC = () => {
  return <ServicePageTemplate slug="software-maintenance" />;
};

export default SoftwareMaintenancePage;
